<template>
  <div>
      <el-dialog title="日报详情" :visible.sync="editHide" :before-close="changeClose">
          <div>
            <div class="journalBody">
              <div class="blogCenter flex-row">
                  <!-- <div class="down-img"><img src="../../../assets/images/staffJounary_headerImg.png" alt=""></div> -->
                  <div class="down-img"><img :src="form.staffAvatar || imgurl"></div>
                  <div class="ml10">
                    <span class="journaltitle">{{form.createName}}的日报</span>
                    <div class="time">{{formatDate(form.createTime)}}</div>
                    
                  </div>
              </div>
              <div class="mains pl10">
                  <div class="journaltitle  mt10">今日总结：</div>
                  <div class="color111 f16 mb30">{{form.summarize}}</div>
                  <div class="journaltitle mt10">明日计划：</div>
                  <div class="color111 f16 mb30">{{form.plan}}</div>
                  <div class="journaltitle mt10">心得体会：</div>
                  <div class="color111 f16 mb10">{{form.experience}}</div>
              </div>
            </div>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
export default{
  data() {
      return {
          form:{
            id: '',
            cardOldType: 'paper',
            name: '',
            achievementAmount: '',
            deductAmount: '',
            ranking: ''
          },
          list:[],
          query:{},
          editHide: false,
          imgurl: require('../../../assets/images/staffJounary_headerImg.png'),
      }
  },
  mixins: [minxin],
  components:{},
  created(){
      this.init();
      
  },
  methods:{
      
      init(){
          this.$on('set', function (org) {
              if(org.id != ''){
                  this.editHide = true;
                  this.serveCategory(org.id);
              } else {

              }
          });
      },
  
      serveCategory(id){
          this.$api.get(this.$url.staffJournal.getDetail,{
              id:id
          }).then( res => {
            if (res) {
              this.form = res;
              
            }
          }).catch( error => { })
      },

      changeClose(show){
          this.editHide = false;
          this.form = {
            id: '',
            cardOldType: 'paper',
            name: '',
            achievementAmount: '',
            deductAmount: '',
            ranking: ''
          };
          this.$emit('change',true);
      },
  }
}
</script>

<style lang="less" scoped>

/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 600px;
  top: calc(50% - 300px);
  border-radius: 10px;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
  .bodys {
    box-sizing: border-box;
    padding: 5px 0;
    
  }
}

.blogCenter {
// position: relative;
// height: 100%;
background-color: #fff;
}

.journalBody {
// padding: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 0px;
  height: 500px;
  overflow: auto;
}
.down-img {

width: 40px;
height: 40px;
border-radius: 50%;
}
.down-img img {
width: 100%;
height: 100%;
border-radius: 50%;
}
.journaltitle {
font-size: 19px;
font-weight: bold;
color: #111;
margin-bottom: 15px;
}

.time {
margin-top: 7.5px;
font-size: 12px;
color: #999;
}

.mains {
margin-top: 32px;
margin-left: 40px;
}
.f16 {
font-size: 16px;
} 
</style>